import { useAppSelector } from '@/store/hooks';
import { Role } from '@/types/Role';
import { hasRole, hasAnyRole, hasAllRoles, hasPermission, canAccessRoute } from '@/utils/roleUtils';
import { useLocation } from 'react-router-dom';

export const useRoleAccess = () => {
  const user = useAppSelector(state => state.auth.user);
  const location = useLocation();
  
  // Default to empty array if user has no roles
  const userRoles: Role[] = (user as any)?.roles || [];
  
  return {
    userRoles,
    hasRole: (role: Role) => hasRole(userRoles, role),
    hasAnyRole: (roles: Role[]) => hasAnyRole(userRoles, roles),
    hasAllRoles: (roles: Role[]) => hasAllRoles(userRoles, roles),
    hasPermission: (resource: string, action: string) => hasPermission(userRoles, resource, action),
    canAccessRoute: (route: string) => canAccessRoute(userRoles, route),
    canAccessCurrentRoute: () => canAccessRoute(userRoles, location.pathname),
    isAuthenticated: !!user,
  };
}; 